import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_GOOGLE_AD_MANAGER_CONNECTION } from './api/query'
import { Data, Variables } from './api/types'
import { GoogleAdManagerConnection, UseGetConnection } from './types'

export const useGetConnection = (): UseGetConnection => {
  const { workspaceId } = useWorkspaceParam()

  const { data, isLoading } = useQuery<Variables, Data, GoogleAdManagerConnection>({
    options: {
      enabled: workspaceId !== undefined,
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
      select: ({
        node: { latestGamConnectionOrder: googleAdManagerConnection },
      }: Data): GoogleAdManagerConnection | undefined =>
        googleAdManagerConnection ? fromDTO(googleAdManagerConnection) : undefined,
    },
    query: GET_GOOGLE_AD_MANAGER_CONNECTION,
    variables: {
      workspaceId,
    },
  })

  return {
    connection: data,
    loading: isLoading,
  }
}
